import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ccc_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        if (error.response?.status === 401) {
            const path = window.location.pathname;
            if (path !== "/login" && path !== "/") {
                localStorage.removeItem("ccc_token");
                localStorage.removeItem("ccc_user");
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    },
);

export const fileUrl = (relative) => {
    if (!relative) return "";
    if (relative.startsWith("http")) return relative;
    return `${BACKEND_URL}${relative}`;
};

export const authedFileUrl = (relative) => {
    const token = localStorage.getItem("ccc_token");
    const sep = relative.includes("?") ? "&" : "?";
    return `${fileUrl(relative)}${sep}token=${encodeURIComponent(token || "")}`;
};
